// apps/canifight/src/screens/Roster.jsx
import { useState } from 'react';
import { FIGHTERS, CAT_COLORS } from '../data/fighters';
import styles from './Roster.module.css';

const CATEGORIES = [
  { key: 'all', label: 'ALL' },
  { key: 'Classic Wild Animal', label: '🦁 WILD' },
  { key: 'Smaller But Scrappy', label: '🦡 SCRAPPY' },
  { key: 'Group of Humans', label: '👥 GROUPS' },
  { key: 'Single Human', label: '🤼 HUMANS' },
  { key: 'Wildcard / Absurd', label: '⚡ ABSURD' },
];

export default function Roster({ userStats, onSelectFighter, onViewStats }) {
  const [activeCat, setActiveCat] = useState('all');

  const yourTotal = userStats.reduce((a, b) => a + b, 0);
  const filtered = activeCat === 'all'
    ? FIGHTERS
    : FIGHTERS.filter(f => f.cat === activeCat);

  const getDifficulty = (total) => {
    if (total > 90) return '🔴🔴🔴';
    if (total > 70) return '🔴🔴⚪';
    if (total > 50) return '🔴⚪⚪';
    return '⚪⚪⚪';
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.top}>
          <div className={styles.title}>PICK YOUR OPPONENT</div>
          <button className={styles.yourStatsMini} onClick={onViewStats}>
            <div>
              <div className={styles.ysmLabel}>YOUR SCORE</div>
              <div className={styles.ysmScore}>{yourTotal}</div>
            </div>
            <span>⚡</span>
          </button>
        </div>
        <div className={styles.tabs}>
          {CATEGORIES.map(cat => (
            <button
              key={cat.key}
              className={`${styles.tab} ${activeCat === cat.key ? styles.tabActive : ''}`}
              onClick={() => setActiveCat(cat.key)}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.grid}>
        {filtered.map((f, idx) => {
          const total = f.stats.reduce((a, b) => a + b, 0);
          const color = CAT_COLORS[f.cat] || '#ff3c3c';
          return (
            <button
              key={f.name}
              className={styles.card}
              style={{ '--cat-color': color }}
              onClick={() => onSelectFighter(FIGHTERS.indexOf(f))}
            >
              <span className={styles.emoji}>{f.emoji}</span>
              <div className={styles.name}>{f.name}</div>
              <div className={styles.powerLabel}>POWER</div>
              <div className={styles.power}>{total}</div>
              <div className={styles.difficulty}>{getDifficulty(total)}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
